import type { WriteOp } from "../components/WriteOpsHint";

export const REALMS_WRITE_OPS: WriteOp[] = [
  {
    channel: "HTTP",
    label: "Realm anlegen (Team)",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" -H "Content-Type: application/json" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/realms \\\n  -d \'{"id": "team:alpha", "kind": "team", "display_name": "Alpha", "pack_bindings": ["kw:base", "kw:personal"]}\'',
  },
  {
    channel: "HTTP",
    label: "Personal-Realm idempotent sicherstellen",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" \\\n  "http://kontextwerk.localhost:8080/core/v1/admin/realms/personal/<subject>/ensure"',
  },
  {
    channel: "HTTP",
    label: "Member hinzufügen",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" -H "Content-Type: application/json" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/realms/<realm_id>/members \\\n  -d \'{"subject": "alice@example.com", "role": "member"}\'',
  },
  {
    channel: "HTTP",
    label: "IdP-Group-Grant setzen",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" -H "Content-Type: application/json" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/realms/grants \\\n  -d \'{"idp_group": "kw-team", "realm_id": "<realm_id>", "role": "member", "scopes": []}\'',
  },
  // The realm/embedding provider bindings moved into the Models tab; only the
  // org-wide binding stays CLI-only (kw:org-admin, no UI surface).
  {
    channel: "CLI",
    label: "Bind an LLM provider org-wide (shared cost, needs kw:org-admin)",
    snippet:
      "kontextwerk-cli realm llm-providers\nkontextwerk-cli realm llm-provider set --org <org_id> --provider <catalog-name>",
  },
];
